<mydocma-tree
  [options]="treeOptions"
  [nodeData]="structures"
  [selectedNodeId]="selected?.Id?.toString()"
  (nodeSelected) ="this.onClick($event)">
</mydocma-tree>
